import { Component, OnInit } from "@angular/core";
import { AppService } from "src/app/app.service";


@Component({
  selector: 'app-multimedia-classroom',
  templateUrl: './multimedia-classroom.component.html',
  styleUrls: ['./multimedia-classroom.component.scss']
})
export class MultimediaClassroomComponent implements OnInit {   
  library_data: any[] = [];
  Multimedia_classroom_data: any;
  constructor(private appService: AppService) {}

  ngOnInit(): void {
    this.FetchData();
  }

  FetchData() {
    this.appService.getContents().subscribe((response: any) => {
      console.log(response, "Multimedia API Response");

      if (response?.data) {
        // Filter for Multimedia category
        this.Multimedia_classroom_data= response.data.filter(
          (x: any) => x.ContentCategoryName === "Multimedia Class Room "
        );
        console.log(this.Multimedia_classroom_data, "Filtered Multimedia Data");
      }
    });
  }
}
